import { render, staticRenderFns } from "./BusinessSettings.vue?vue&type=template&id=54025424"
import script from "./BusinessSettings.vue?vue&type=script&lang=js"
export * from "./BusinessSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports